import pick from 'lodash/pick';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { addApiError } from '../actions/app';
import { SET_USER_GROUPS } from '../constants';
import { USER_MODEL_EDITABLE_PROPERTIES } from '../../models/user';
import { addGroupUser, removeGroupUser } from '../../api/groups-api';
import { getUserGroups } from '../../api/legacy-user-api';
import { groupUserAddedError, loadGroups } from '../actions/groups';
import { updateUserSuccess, updateUserError } from '../actions/users';
import { usersByIdSelector } from '../selectors/users';

export function* setUserGroupsSagaGenerator({ payload: form }) {
  try {
    const groups = yield select(state => state.groups.byId);

    const oldGroups = Object.keys(groups).reduce((accum, groupId) => {
      const userIndex = groups[groupId].users.indexOf(form.id);
      if (userIndex !== -1) {
        accum.push(groupId);
      }
      return accum;
    }, []);

    const { id: userId, team: newGroups } = form;

    const toAdd = newGroups.filter(id => !oldGroups.includes(id));
    const toRemove = oldGroups.filter(id => !newGroups.includes(id));

    const actions = [
      ...toAdd.map(groupId => call(addGroupUser, groupId, userId)),
      ...toRemove.map(groupId => call(removeGroupUser, groupId, userId)),
    ];

    yield all(actions);
    yield put(loadGroups());
  } catch (e) {
    yield put(groupUserAddedError(e));
    yield put(addApiError(e.applicationError));
  }
}

function* usersSaga() {
  yield takeLatest(SET_USER_GROUPS, setUserGroupsSagaGenerator);
}

export default usersSaga;
